import React, { useEffect, useState } from 'react';
import { Phone } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-white/95 backdrop-blur-sm py-4'}`} data-id="element-27">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between" data-id="element-28">
        {/* Logo Area */}
        <div className="flex items-center" data-id="element-29">
          <div className="flex flex-col" data-id="element-30">
            <span className="text-xl md:text-2xl font-black tracking-tighter text-gray-900 uppercase leading-none" data-id="element-31">
              Watson
            </span>
            <span className="text-xs md:text-sm font-bold tracking-widest text-red-600 uppercase leading-none" data-id="element-32">
              Martial Arts
            </span>
          </div>
        </div>

        {/* Desktop Nav & CTA */}
        <div className="flex items-center gap-4" data-id="element-33">
          <a href="tel:555-928-7661" className="hidden md:flex items-center gap-2 text-gray-700 hover:text-red-600 font-semibold transition-colors" data-id="element-34">
            <Phone className="w-4 h-4" data-id="element-35" />
            <span data-id="element-36">(555) WATSON-1</span>
          </a>
          <Button size="sm" className="hidden sm:inline-flex" data-id="element-37">
            Book Free Class
          </Button>

          {/* Mobile Call Icon */}
          <a href="tel:555-928-7661" className="sm:hidden p-2 text-gray-900 bg-gray-100 rounded-full hover:bg-gray-200" aria-label="Call Now" data-id="element-38">
            <Phone className="w-5 h-5" data-id="element-39" />
          </a>
        </div>
      </div>
    </header>;
}